// extracted by mini-css-extract-plugin
export default {"generated":"ImageGenerated_generated__pBpAu","generated__imgLoaderBlock":"ImageGenerated_generated__imgLoaderBlock__1tooB"};